import { environment } from 'src/environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppBarComponent } from './components/app-bar/app-bar.component';
import { MenuComponent } from './components/menu/menu.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { RegisterComponent } from './components/auth-modal/register/register.component';
import { SignInComponent } from './components/auth-modal/sign-in/sign-in.component';
import { AuthModalComponent } from './components/auth-modal/auth-modal.component';
import { PageComponent } from './pages/page/page.component';
import { CollectionsComponent } from './pages/collections/collections.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import {
  AngularFireAnalyticsModule,
  ScreenTrackingService,
  UserTrackingService,
} from '@angular/fire/analytics';
import { EditCollectionModalComponent } from './components/edit-collection-modal/edit-collection-modal.component';
import { AddToCollectionModalComponent } from './add-to-collection-modal/add-to-collection-modal.component';
import { CollectionComponent } from './pages/collection/collection.component';
import { PageCardComponent } from './components/page-card/page-card.component';

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    AppBarComponent,
    MenuComponent,
    GalleryComponent,
    UserMenuComponent,
    RegisterComponent,
    AuthModalComponent,
    PageComponent,
    CollectionsComponent,
    EmptyStateComponent,
    EditCollectionModalComponent,
    AddToCollectionModalComponent,
    CollectionComponent,
    PageCardComponent,
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebaseConfig),
    BrowserModule,
    AppRoutingModule,
    AngularFireAnalyticsModule,
  ],
  providers: [ScreenTrackingService, UserTrackingService],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
